<template>
    <div class="text-center">
      <v-dialog persistent v-model="visible" width="800">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-eye</v-icon> Visualizar Função
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  :value="content.nome"
                  label="Nome da Função"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                  Tipo do Profissional
                  <v-radio-group
                    v-model="content.servidorDoEstado"
                    outlined
                    dense
                    readonly
                  >
                    <v-radio
                      label="Servidor do Estado de PE"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      label="Profissional externo"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="content.atividades"
                    label="Atividades"
                    readonly
                    outlined
                    dense
                  ></v-textarea>
                </v-col>
            </v-row>
          </div>
          <div class="btn-group text-center">
            <v-btn color="primary" @click="$emit('onClose')">
              <v-icon>mdi-close</v-icon>
              Fechar
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </template>

  <script>
  import { DialogProps } from '~/commons/classes/dialog-props';
  import { Funcao } from '~/commons/classes/funcao';

  export default {
    props: new DialogProps(Funcao),
    data: () => ({
      form: {
        nome: null,
        servidorDoEstado: null,
        lists: {
        },
      },
    }),
  };
  </script>
